<template>
  <a-modal
    v-model:open="pdfModalShow"
    centered
    destroy-on-close
    :title="props.title"
    width="400px"
    :footer="null"
    :body-style="{ padding: '30px', height: '200px', overflow: 'hidden' }"
    :after-close="hiddenModal"
    :mask-closable="false"
  >
    <div>
      <a-button
type="primary" @click="selectPdf" :disabled="pdfBtnDisabled">上传PDF</a-button>
      <div style="margin-top: 10px">
        {{ pdfResult }}
      </div>
      <div
v-show="pdfTipShow" style="margin-top: 10px; color: #f00">上传/转换过程中，请勿关闭弹窗！</div>
      <input
v-show="false" type="file" ref="pdfUploadRef" accept="application/pdf" @change="pdfChange" />
    </div>
  </a-modal>
</template>

<script setup>
  import { ref, toRefs, watch, reactive } from 'vue'
  import { updateTmpPdf, getTmpPdfState, submitPdfToHtml, getPdfToHtmlState } from '@/api/project/ziliao/ziliaoManage'
  import { useGetters } from '@/utils/composables'

  const props = defineProps({
    show: {
      type: Boolean,
      default: false,
    },
    trigger_click: {
      type: Boolean,
      default: false,
    },
    file_type: {
      type: String,
      default: '1',
    }, //区分 大纲-3 或 考点-1
    title: {
      type: String,
      default: 'PDF转图片',
    }, // 标题
  })
  const { show, trigger_click, file_type } = toRefs(props) // 解构新增属性
  watch(show, (val) => {
    if (val) {
      pdfModalShow.value = val
      if (trigger_click.value && !pdfBtnDisabled.value) {
        setTimeout(() => {
          selectPdf()
        })
      }
    }
  })

  const emit = defineEmits(['success', 'update:show'])
  const { api_url } = useGetters('settings', ['api_url'])

  const pdfModalShow = ref(false) // pdf组件控制
  const pdfUploadRef = ref(null)
  const pdfResult = ref('')
  const pdfTipShow = ref(false)
  const pdfTransformTimer = ref(null)
  const pdfBtnDisabled = ref(false)
  const pdfInfo = reactive({
    name: '',
    url: '',
  })

  const pdfChange = (e) => {
    if (e.target.files.length == 0) return
    pdfBtnDisabled.value = true
    const file = e.target.files[0]
    const filename = file.name
    const filesize = file.size
    const f = new FormData()
    f.append('file', file)
    pdfResult.value = '上传中...'
    pdfTipShow.value = true
    const xhr = new XMLHttpRequest()
    const baseUrl = process.env.NODE_ENV === 'development' ? 'http://admin.dev.ehafo.com' : api_url.value
    xhr.open('POST', baseUrl + '/phalapi/public/?service=App.Common.uplodeUpyun', true)
    xhr.onloadend = function () {
      // $('#file').val(null)
      const ret = JSON.parse(xhr.responseText)
      if (ret.code === 0) {
        if (file_type.value == 3) {
          // 根据file_type选择不同的处理流程
          submitPdf(ret.data, filename, filesize)
        } else {
          uploadPdf(ret.data, filename, filesize)
        }
      } else {
        pdfResult.value = ret.msg
        pdfBtnDisabled.value = false
      }
    }
    xhr.send(f)
  }

  // 上传pdf链接
  const uploadPdf = async (url, name, size) => {
    const param = {
      title: name,
      size: size,
      link: url,
    }
    pdfInfo.name = name
    pdfInfo.url = url
    const res = await updateTmpPdf(param)
    if (res.code == 0) {
      pdfResult.value = '上传完成，等待转换中...'
      if (pdfTransformTimer.value != null) {
        clearInterval(pdfTransformTimer.value)
        pdfTransformTimer.value = null
      }
      pdfTransformTimer.value = setInterval(function () {
        checkTransformState(res.data.id)
      }, 1000)
    } else {
      pdfResult.value = res.msg
      pdfBtnDisabled.value = false
    }
  }

  // 提交pdf转换任务
  const submitPdf = async (url, name) => {
    const param = {
      link: url,
    }
    pdfInfo.name = name
    pdfInfo.url = url
    const res = await submitPdfToHtml(param)
    if (res.code == 0) {
      pdfResult.value = '上传完成，等待转换中...'
      if (pdfTransformTimer.value != null) {
        clearInterval(pdfTransformTimer.value)
        pdfTransformTimer.value = null
      }
      pdfTransformTimer.value = setInterval(function () {
        checkHtmlTransformState(res.data.uuid)
      }, 1000)
    } else {
      pdfResult.value = res.msg
      pdfBtnDisabled.value = false
    }
  }

  // 检查转换状态
  const isChecking = ref(false)
  const checkTransformState = async (id) => {
    if (isChecking.value) {
      return
    } else {
      isChecking.value = true
    }
    const res = await getTmpPdfState({ id: id })
    isChecking.value = false
    if (res.code == 0) {
      const state = res.data.state
      if (state == 2) {
        if (pdfTransformTimer.value != null) {
          clearInterval(pdfTransformTimer.value)
          pdfTransformTimer.value = null
        }
        const imgList = res.data.img_list
        let _html = ''
        imgList.forEach(function (img) {
          _html += '<img style="max-width: 100%" src="' + img + '">'
        })
        emit('success', _html, { pdfInfo: pdfInfo })
        pdfModalShow.value = false
        pdfBtnDisabled.value = false
        pdfTipShow.value = false
        pdfResult.value = ''
      } else if (state == 1) {
        pdfResult.value = '转换中...'
      } else {
        pdfResult.value = '上传完成，等待转换中...'
      }
    } else {
      if (pdfTransformTimer.value != null) {
        clearInterval(pdfTransformTimer.value)
        pdfTransformTimer.value = null
      }
      pdfResult.value = res.msg
      pdfBtnDisabled.value = false
    }
  }

  // 检查html转换状态
  const checkHtmlTransformState = async (uuid) => {
    if (isChecking.value) {
      return
    } else {
      isChecking.value = true
    }
    const res = await getPdfToHtmlState({ uuid: uuid })
    isChecking.value = false
    if (res.code == 0) {
      const state = res.data.state
      if (state == 2) {
        if (pdfTransformTimer.value != null) {
          clearInterval(pdfTransformTimer.value)
          pdfTransformTimer.value = null
        }
        const _html = res.data.origin_res
        //apiData中包含getPdfToHtmlState的返回参数
        emit('success', _html, { pdfInfo: pdfInfo, apiData: res.data })
        pdfModalShow.value = false
        pdfBtnDisabled.value = false
        pdfTipShow.value = false
        pdfResult.value = ''
      } else if (state == 1) {
        pdfResult.value = '转换中...'
      } else {
        pdfResult.value = '任务已提交，等待转换中...'
      }
    } else {
      if (pdfTransformTimer.value != null) {
        clearInterval(pdfTransformTimer.value)
        pdfTransformTimer.value = null
      }
      pdfResult.value = res.msg
      pdfBtnDisabled.value = false
      pdfTipShow.value = false
    }
  }

  const hiddenModal = () => {
    emit('update:show', false)
  }

  const selectPdf = () => {
    if (pdfUploadRef.value) {
      pdfUploadRef.value.click()
    }
  }
</script>

<style lang="scss" scoped></style>
